// api 地址： https://cnpm.zhuanspirit.com/package/@zz-eg/common-lib

import {
  getQueryParam, // 获取url中query部分指定的参数，并返回
  setQueryParam, // 向url中query部分添加参数，并返回处理后的链接
  getHashParam, // 获取url中hash部分指定的参数，并返回
  setHashParam, // 向url的hash部分添加参数，并返回处理后的链接
  getQueryObject, // 将url中query部分的参数转换为数据对象，并返回
  getHashObject, // 将url中hash部分的参数转换为数据对象，并返回
  getParam // 获取url中指定的参数并返回，优先从hash中取，hash没有再从query中取
} from '@zz-eg/common-lib/dist/url'

export default {
  getQueryParam,
  setQueryParam,
  getHashParam,
  setHashParam,
  getQueryObject,
  getHashObject,
  getParam
}
